import { useState } from "react";
import { Dialog } from "@headlessui/react";
import styles from "./PopupDialog.module.css";
import DateScrollPicker from "@components/datePicker/datePicker";
import { updateUserModel } from "@services/userAPI";
import { Spinner } from "@components/Spinner/Spinner";
import Cookies from "js-cookie";

export default function UpdateFields({ open, isClosed, user }) {
  // The open/closed state lives outside of the Dialog and is managed by you
  const [isOpen, setIsOpen] = useState(open);
  const [isLoading, setIsLoading] = useState(false);
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [day, setDay] = useState("");
  const [error, setError] = useState("");
  async function handleSubmit() {
    // Validate the selected date

    if (!year || !month || !day) {
      setError("Please select a valid date.");
      return;
    }

    const parsedYear = parseInt(year, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedDay = parseInt(day, 10);

    if (isNaN(parsedYear) || isNaN(parsedMonth) || isNaN(parsedDay)) {
      setError("Please enter valid numeric values for year, month, and day.");

      return;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const daysInCurrentMonth = new Date(
      currentDate.getFullYear(),
      currentMonth,
      0
    ).getDate();

    if (parsedYear < currentYear - 100 || parsedYear > currentYear) {
      setError("Please select a valid year.");
      return;
    }

    if (parsedMonth < 1 || parsedMonth > 12) {
      setError("Please select a valid  month (1 - 12).");
      return;
    }

    if (parsedDay < 1 || parsedDay > daysInCurrentMonth) {
      setError("Please select a valid day (1 - ${daysInCurrentMonth}).");

      return;
    }
    setIsLoading(true);
    const update = await updateUserModel(
      user.id,
      user.idToken,
      user.refreshToken,
      `${parsedYear}-${parsedMonth}-${parsedDay}`
    );
    if (update.status === "success")
      Cookies.set(
        "user",
        JSON.stringify({
          id: update.data.uid,
          email: update.data.email,
          idToken: update.data.idToken,
          refreshToken: update.data.refreshToken,
          fname: update.data.fName,
          lastName: update.data.lastName,
          country: update.data.address,
          phoneNumber: update.data.phoneNumber,
          gender: update.data.gender,
          dob: update.data.bDate,
          updatedFields: update.data.updatedFields,
        })
      );
    // Implement your account deactivation logic here
    // For example: API calls, changing state, etc.
    setIsOpen(false); // Close the dialog after the action is completed
    isClosed();
  }

  // Get current date to set the range for the year, month, and day inputs
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // Adding 1 because months are 0-based
  const daysInCurrentMonth = new Date(
    currentDate.getFullYear(),
    currentMonth,
    0
  ).getDate();

  // Generate arrays for the year, month, and day options
  const yearOptions = generateRange(currentYear - 100, currentYear - 18);
  const monthOptions = generateRange(1, 12);
  const dayOptions = generateRange(1, daysInCurrentMonth);

  // Function to generate an array of numbers from start to end
  function generateRange(start, end) {
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  return (
    <Dialog className={styles.dialogMain} open={isOpen}>
      <Dialog.Panel>
        <div className={styles.dialogPanel}>
          <h2 className={styles.dialogTitle}>Birth Date</h2>
          <p className={styles.dialogDescription}>
            For a better experience, please provide a valid birth date.
          </p>

          <div className={styles.dialogContent}>
            <input
              type="number"
              name="year"
              placeholder={`Year (e.g., ${currentYear - 100} - ${currentYear})`}
              className={styles.year}
              value={year}
              onChange={(e) => setYear(e.target.value)}
              min={yearOptions[0]}
              max={yearOptions[yearOptions.length - 1]}
            />
            &nbsp; / &nbsp;
            <input
              type="number"
              name="month"
              placeholder={`Month (e.g., 1 - 12)`}
              className={styles.month}
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              min={monthOptions[0]}
              max={monthOptions[monthOptions.length - 1]}
            />
            &nbsp; / &nbsp;
            <input
              type="number"
              name="day"
              placeholder={`Day (e.g., 1 - ${daysInCurrentMonth})`}
              className={styles.day}
              value={day}
              onChange={(e) => setDay(e.target.value)}
              min={dayOptions[0]}
              max={dayOptions[dayOptions.length - 1]}
            />
          </div>
          {error !== "" && (
            <p style={{ color: "red", lineHeight: "15px", fontSize: "12px" }}>
              {" "}
              {error}
            </p>
          )}
          <div className={styles.dialogButtons}>
            <button disabled={isLoading} onClick={() => handleSubmit()}>
              {isLoading ? <Spinner /> : `Submit`}
            </button>
          </div>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
}
